import React from 'react';

export const PublishIcon = ({ width = 24, height = 24, color = '#fff' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6L19 12L13 18V14C13 14 8 13.5 5 17C5 10 10.6667 10 13 10V6Z"
      fill={color}
    />
  </svg>
);
